import { ethers } from "ethers";

import MarginxTxAbi from "@/connect/abi/MarginxTxAbi.js";

export default class MarginxTxContract extends ethers.Contract {
  constructor(
    _provider,
    account,
    contract = "0x603871c2ddd41c26Ee77495E2E31e6De7f9957e0"
  ) {
    super(contract, MarginxTxAbi, _provider.getSigner(account));
  }
}
